<template>
    <v-container fluid>
        <v-slide-y-transition mode="out-in">
            <v-row>
                <v-col>
                    <template>
                        <v-card>
                            <v-card-text>
                                <v-row class="mt-n5">
                                    <v-col cols="10">
                                        <v-row>
                                            <v-col cols="4">
                                                <v-text-field v-model="searchText"
                                                              append-icon="mdi-magnify"
                                                              :label="$store.state.conf.isService ? 'Ricerca un servizio':'Ricerca una pratica'"
                                                              single-line
                                                              :hint="hintSelezione"
                                                              persistent-hint
                                                              outlined
                                                              clearable
                                                              @keyup="changeSearch"
                                                              dense>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-select v-model="operatore.id"
                                                          :items="listaOperatore"
                                                          item-value="id"
                                                          item-text="denominazioneNormalizzata"
                                                          label="Filtra per Operatore con Task assegnato"
                                                          :disabled="isAccessoLimitatoO"
                                                          clearable
                                                          outlined
                                                          @change="changeSearch"
                                                          dense>
                                                            <template v-slot:item="data">
                                                                <template>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title :class="'text-subtitle-2 font-weight-medium '+(data.item.isCancellato ? 'red--text':'')">{{data.item.denominazioneNormalizzata}}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                </template>
                                                            </template>
                                                        </v-select>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-select v-model="operatore2.id"
                                                          :items="listaOperatore"
                                                          item-value="id"
                                                          item-text="denominazioneNormalizzata"
                                                          label="Filtra per Operatore con Task non completato"
                                                          clearable
                                                          outlined
                                                          @change="changeSearch"
                                                          dense>
                                                          <template v-slot:item="data">
                                                            <template>
                                                                <v-list-item-content>
                                                                    <v-list-item-title :class="'text-subtitle-2 font-weight-medium '+(data.item.isCancellato ? 'red--text':'')">{{data.item.denominazioneNormalizzata}}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </template>
                                                          </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n8">
                                            <v-col cols="2">
                                                <v-text-field class="mt-2"
                                                              v-model="dataDa"
                                                              label="Dal giorno di inizio"
                                                              outlined
                                                              clearable
                                                              persistent-hint
                                                              type="date"
                                                              @change="changeSearch"
                                                              dense>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-text-field class="mt-2"
                                                              v-model="dataA"
                                                              label="Al giorno di inizio"
                                                              outlined
                                                              clearable
                                                              persistent-hint
                                                              type="date"
                                                              @change="changeSearch"
                                                              dense>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-text-field class="mt-2"
                                                              v-model="dataDas"
                                                              label="Dal giorno di scadenza"
                                                              outlined
                                                              clearable
                                                              persistent-hint
                                                              type="date"
                                                              @change="changeSearch"
                                                              dense>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="2">
                                                <v-text-field class="mt-2"
                                                              v-model="dataAs"
                                                              label="Al giorno di scadenza"
                                                              outlined
                                                              clearable
                                                              persistent-hint
                                                              type="date"
                                                              @change="changeSearch"
                                                              dense>
                                                </v-text-field>
                                            </v-col>
                                            <v-col v-if="!$store.state.conf.isService" cols="3">
                                                <v-select
                                                          v-model="professionista.id"
                                                          :items="listaOperatoriProfessionisti"
                                                          item-value="professionista.id"
                                                          item-text="denominazioneNormalizzata"
                                                          label="Professionista"
                                                          clearable
                                                          :disabled="isAccessoLimitatoP"
                                                          class="mt-2"
                                                          outlined
                                                          @change="changeSearch"
                                                          dense></v-select>
                                            </v-col>
                                            <v-col cols="1" class="mt-2">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon
                                                               color="teal"
                                                               v-bind="attrs"
                                                               v-on="on"
                                                               @click="nuovo">
                                                            <v-icon class="ma-0">mdi-calendar-plus</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span v-html="$store.state.conf.isService ? 'Nuovo Servizio':'Nuova Pratica'" />
                                                </v-tooltip>
                                            </v-col>
                                            <v-col cols="3" class="mt-n4" v-if="$store.state.conf.isService">                                                
                                                <v-switch class="mt-6"
                                                          v-model="isApp"
                                                          @click="changeSearch"
                                                          :label="isApp ? 'solo da App' : 'tutti i servizi'">
                                                </v-switch>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n8" v-if="$store.state.conf.isService">
                                            <v-col cols="6">
                                                <v-autocomplete v-model="idCliente"
                                                                :disabled="!isCliente"
                                                                :items="listaCliente"
                                                                item-value="cliente.id"
                                                                item-text="cliente.denominazioneNormalizzata"
                                                                :label="isCliente ? 'Selezionare un Cliente' : 'Ricerca standard'"
                                                                outlined
                                                                @change="change"
                                                                clearable
                                                                dense></v-autocomplete>
                                            </v-col>
                                            <v-col col="6">
                                                <v-switch class="mt-n2" 
                                                          v-model="isCliente"
                                                          @click="changeSwitchCliente"
                                                          :label="isCliente ? 'Cliente senza limiti di tempo' : 'ricerca standard'">
                                                </v-switch>
                                                <v-switch v-if="!isCliente" class="mt-n6"
                                                          v-model="storico"
                                                          @click="change"
                                                          :label="storico ? 'storico: ultimi 2 anni' : 'storico: ultimi 3 mesi'">
                                                </v-switch>
                                            </v-col>
                                           
                                        </v-row>
                                    </v-col>
                                    <v-col class="mt-1">
                                        <v-row>
                                            <v-radio-group @change="changeSearch" hide-details class="mt-0 mx-5" v-model="statoPratica" row mandatory>
                                                <v-radio value="4">
                                                    <template v-slot:label>
                                                        <div style="font-size:small">In lavorazione</div>
                                                    </template>
                                                </v-radio>
                                                <v-radio v-if="$store.state.conf.isService" value="1">
                                                    <template v-slot:label>
                                                        <div style="font-size:small" v-if="$store.state.conf.isService">Servizi aperti</div>
                                                        <div style="font-size:small" v-else>Pratiche aperte</div>
                                                    </template>
                                                </v-radio>
                                                <v-radio value="5">
                                                    <template v-slot:label>
                                                        <div style="font-size:small" v-if="$store.state.conf.isService">Non addebitati</div>
                                                        <div style="font-size:small" v-else>Non addebitate</div>
                                                    </template>
                                                </v-radio>
                                                <v-radio value="2">
                                                    <template v-slot:label>
                                                        <div style="font-size:small" v-if="$store.state.conf.isService">Tutti i servizi</div>
                                                        <div style="font-size:small" v-else>Tutte le pratiche</div>
                                                    </template>
                                                </v-radio>
                                                <v-radio value="3">
                                                    <template v-slot:label>
                                                        <div style="font-size:small" v-if="$store.state.conf.isService">Servizi chiusi</div>
                                                        <div style="font-size:small" v-else>Pratiche chiuse</div>
                                                    </template>
                                                </v-radio>
                                            </v-radio-group>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>                            
                            <v-data-table v-if="$store.state.conf.isService"
                                          v-model="selezione"
                                          :headers="headers1"
                                          :items="praticheEstese"
                                          :loading="loading.value"
                                          ref="tabella"
                                          :item-key="pratica.id"
                                          :items-per-page="nPag"
                                          class="elevation-1 mt-n8"
                                          :footer-props="{
                                            'items-per-page-text':'Pagina da',
                                            'items-per-page-all-text': 'Tutti',
                                            'items-per-page-options':[5,8,10,20,-1]
                                          }"
                                          @current-items="filterItems"
                                          @pagination="pagination"
                                          :search="search"
                                          :custom-filter="customFilter"
                                          loading-text="Caricamento dati..."
                                          :no-data-text="$store.state.conf.isService ? 'Nessun servizio presente in archivio':'Nessuna pratica presente in archivio'"
                                          :no-results-text="$store.state.conf.isService ? 'Nessun servizio corrisponde ai criteri di ricerca':'Nessuna pratica corrisponde ai criteri di ricerca'">
                                          <template v-slot:progress>
                                            <v-progress-linear   
                                             v-model="loading.progress" :indeterminate="loading.indeterminate">
                                            </v-progress-linear>
                                        </template>
                                          
                                          <template v-slot:item.menu="{item}">
                                            <v-btn icon>
                                                <v-icon color="orange darken-2" @click="anagrafica(item.pratica)">
                                                    mdi-launch
                                                </v-icon>
                                            </v-btn>
                                        </template>

                                <template v-slot:item.creazione="{ item }">
                                    <span v-if="item.pratica.operatoreCreazione" class="font-weight-light" v-text="item.pratica.operatoreCreazione.denominazioneNormalizzata" />
                                    <br  v-if="item.pratica.operatoreCreazione"/>
                                    <span class="text-subtitle" v-text="localData(item.pratica.dataCreazione)" />
                                </template>
                                <template v-slot:item.pratica.dataInizio="{ item }">
                                    <span class="text-subtitle" v-text="localData(item.pratica.dataInizio)" />
                                </template>
                                <template v-slot:item.pratica.tipoPratica.descrizione="{ item }">
                                    <span v-text="item.pratica.tipoPratica.descrizione" /> [<span v-text="item.pratica.numeroPratica" />]
                                    <br/>
                                    <span v-text="item.pratica.descrizione" class="font-weight-light" />
                                    <br />
                                    <v-chip class="mb-1" v-if="item.pratica.isApp" small dark label color="teal">
                                        Richiesta APP
                                    </v-chip>
                                    <v-chip class="mb-1" v-if="item.pratica.contratto && item.pratica.importo == 0" small dark label color="orange">
                                        Da contratto
                                    </v-chip>
                                    <v-chip class="mb-1" v-if="item.pratica.contratto && item.pratica.importo > 0" small dark label color="green">
                                        A gettone
                                    </v-chip>

                                </template>
                                <template v-slot:item.pratica.cliente.codice="{ item }">
                                    <span v-text="item.pratica.cliente.codice" />
                                    <br />
                                    <span class="font-weight-light" v-text="item.pratica.cliente.denominazioneNormalizzata" />
                                </template>

                                <template v-slot:item.operatoriProgress="{ item }">
                                    <v-chip small dark color="blue light"
                                            v-for="operatore in item.listaOperatoriTaskProgress"
                                            :key="operatore.id"
                                            v-text="operatore.nomeInizialeCognome">
                                    </v-chip>
                                </template>
                                <template v-slot:item.operatoriAperti="{ item }">
                                    <v-chip small dark color="red darken-3"
                                            v-for="operatore in item.listaOperatoriTaskAperti"
                                            :key="operatore.id"
                                            v-text="operatore.nomeInizialeCognome">
                                    </v-chip>
                                </template>
                                <template v-slot:item.operatoriChiusi="{ item }">
                                    <v-chip small dark color="teal"
                                            v-for="operatore in item.listaOperatoriTaskChiusi"
                                            :key="operatore.id"
                                            v-text="operatore.nomeInizialeCognome">
                                    </v-chip>
                                </template>
                                <template v-slot:item.pratica.dataScadenza="{ item }">
                                    <span class="text-subtitle" v-text="localData(item.pratica.dataScadenza)" />
                                </template>

                                <template v-slot:item.task1="{ item }">
                                    <span>{{item.taskProgress}}/{{item.taskAperti}}/{{item.taskChiusi}}</span>
                                </template>

                                <template v-slot:item.chiusa="{ item }">
                                    <v-icon v-if="item.pratica.isChiusa" color="teal" dense>mdi-check-bold</v-icon>
                                    <v-tooltip v-if="item.addebito" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" color="blue" dense>mdi-currency-eur</v-icon>
                                        </template>
                                        <span>{{importoEuro(item.addebito.importo)}}</span>
                                    </v-tooltip>
                                    <v-tooltip v-if="(item.isAddebitabile && !item.pratica.contratto) || (item.isAddebitabile && item.pratica.contratto && item.pratica.importo > 0)" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" color="orange" dense>mdi-currency-eur</v-icon>
                                        </template>
                                        <span>Servizio non addebitato</span>
                                    </v-tooltip>
                                    <v-tooltip v-if="item.pratica.contratto && item.pratica.importo <= 0" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" color="grey" dense>mdi-currency-eur-off</v-icon>
                                        </template>
                                        <span>Servizio non addebitabile (da contratto)</span>
                                    </v-tooltip>
                                </template>
                                <template v-slot:header.chiusa="{ item }">
                                    <v-icon small color="teal">mdi-check-bold</v-icon>
                                    <span v-html="$store.state.conf.isService ? 'Chiuso':'Chiusa'" />
                                    <br />
                                    <v-icon small color="blue">mdi-currency-eur</v-icon>
                                    <span v-html="$store.state.conf.isService ? 'Addebitato':'Addebitata'" />
                                </template>
                            </v-data-table>
                            <v-data-table v-else
                                          v-model="selezione"
                                          :headers="headers"
                                          :items="praticheEstese"
                                          ref="tabella"
                                          :item-key="pratica.id"
                                          :loading="loading.value"
                                          :items-per-page="nPag"
                                          class="elevation-1 mt-n8"
                                          :footer-props="{
                                            'items-per-page-text':'Pagina da',
                                            'items-per-page-all-text': 'Tutti',
                                            'items-per-page-options':[5,8,10,20,-1]
                                          }"
                                          @current-items="filterItems"
                                          @pagination="pagination"
                                          :search="search"
                                          :custom-filter="customFilter"
                                          loading-text="Caricamento dati..."
                                          :no-data-text="$store.state.conf.isService ? 'Nessun servizio presente in archivio':'Nessuna pratica presente in archivio'"
                                          :no-results-text="$store.state.conf.isService ? 'Nessun servizio corrisponde ai criteri di ricerca':'Nessuna pratica corrisponde ai criteri di ricerca'">
                                <template v-slot:progress>
                                    <v-progress-linear v-model="loading.progress" :indeterminate="loading.indeterminate"></v-progress-linear>
                                </template>
                                <template v-slot:item.menu="{item}">
                                    <v-btn icon>
                                        <v-icon color="orange darken-2" @click="anagrafica(item.pratica)">
                                            mdi-launch
                                        </v-icon>
                                    </v-btn>

                                </template>

                                <template v-slot:item.creazione="{ item }">
                                    <span class="font-weight-light" v-text="item.pratica.operatoreCreazione.denominazioneNormalizzata" />
                                    <br />
                                    <span class="text-subtitle" v-text="localData(item.pratica.dataCreazione)" />
                                </template>
                                <template v-slot:item.pratica.dataInizio="{ item }">
                                    <span class="text-subtitle" v-text="localData(item.pratica.dataInizio)" />
                                </template>
                                <template v-slot:item.pratica.tipoPratica.descrizione="{ item }">
                                    <span v-text="item.pratica.tipoPratica.descrizione" /> [<span v-text="item.pratica.numeroPratica" />]
                                    <br />
                                    <span class="font-weight-light" v-text="item.pratica.descrizione" />
                                    <br/>
                                    <v-chip small dark color="gray"
                                            v-for="tag in item.pratica.tagList"
                                            :key="tag"
                                            @click="setTagRicerca(tag)"
                                            v-text="tag">
                                    </v-chip>
                                </template>
                                <template v-slot:item.pratica.cliente.codice="{ item }">
                                    <span v-text="item.pratica.cliente.codice" />
                                    <br />
                                    <span class="font-weight-light" v-text="item.pratica.cliente.denominazioneNormalizzata" />
                                </template>

                                <template v-slot:item.operatoriProgress="{ item }">
                                    <v-chip small dark color="blue light"
                                            v-for="operatore in item.listaOperatoriTaskProgress"
                                            :key="operatore.id"
                                            v-text="operatore.nomeNormalizzato">
                                    </v-chip>
                                </template>
                                <template v-slot:item.operatoriAperti="{ item }">
                                    <v-chip small dark color="red darken-3"
                                            v-for="operatore in item.listaOperatoriTaskAperti"
                                            :key="operatore.id"
                                            v-text="operatore.nomeNormalizzato">
                                    </v-chip>
                                </template>
                                <template v-slot:item.operatoriChiusi="{ item }">
                                    <v-chip small dark color="teal"
                                            v-for="operatore in item.listaOperatoriTaskChiusi"
                                            :key="operatore.id"
                                            v-text="operatore.nomeNormalizzato">
                                    </v-chip>
                                </template>
                                <template v-slot:item.pratica.dataScadenza="{ item }">
                                    <span class="text-subtitle" v-text="localData(item.pratica.dataScadenza)" />
                                </template>

                                <template v-slot:item.task="{ item }">
                                    <span>{{item.taskAperti}}/{{item.taskChiusi}}</span>
                                </template>

                                <template v-slot:item.chiusa="{ item }">
                                    <v-icon v-if="item.pratica.isChiusa" color="teal" dense>mdi-check-bold</v-icon>
                                    <v-tooltip v-if="item.addebito" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" color="blue" dense>mdi-currency-eur</v-icon>
                                        </template>
                                        <span>{{importoEuro(item.addebito.importo)}}</span>
                                    </v-tooltip>
                                    <v-tooltip v-if="item.isAddebitabile" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" color="orange" dense>mdi-currency-eur</v-icon>
                                        </template>
                                        <span>Pratica non addebitata</span>
                                    </v-tooltip>
                                </template>
                                <template v-slot:header.chiusa="{ item }">
                                    <v-icon small color="teal">mdi-check-bold</v-icon>
                                    <span v-html="$store.state.conf.isService ? 'Chiuso':'Chiusa'" />
                                    <br />
                                    <v-icon small color="blue">mdi-currency-eur</v-icon>
                                    <span v-html="$store.state.conf.isService ? 'Addebitato':'Addebitata'" />
                                </template>
                            </v-data-table>
                        </v-card>
                    </template>
                </v-col>
            </v-row>
        </v-slide-y-transition>

        <v-snackbar v-model="snackSuccess"
                    timeout="2000"
                    color="success">
            <v-icon dark>
                mdi-checkbox-marked-circle
            </v-icon>
            Operazione eseguita con successo.
        </v-snackbar>
        <v-snackbar v-model="snackError"
                    timeout="2000"
                    color="error">
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Errore durante l'esecuzione dell'operazione.
        </v-snackbar>
        <v-snackbar v-model="snackCancel"
                    timeout="2000"
                    color="warning">
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Modifiche annullate.
        </v-snackbar>
        <v-snackbar v-model="snackRemote"
                    timeout="2000"
                    color="info">
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Aggiornamento remoto.
        </v-snackbar>


    </v-container>   

</template>




<script>
    import { callService,callPost, euro, gLocalData, gCheckData, gServerData, gDataCalendar, gControllData, gSynch6, Snack } from '@/modules/utilities.js'
    import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr'

    import { bus } from '@/main.js'

    export default {
                
                data: () => ({
                    connection: null,
                    selezione: [],
                    filtro: [],
                    statoAll: false,
                    showError: false,
                    isApp: false,
                    isCliente: false,
                    viewMenuUtente: false,
                    snackSuccess: false,
                    snackError: false,
                    snackCancel: false,
                    snackRemote: false,
                    isAccessoLimitatoP: false,
                    isAccessoLimitatoO: false,
                    x: 0,
                    y: 0,
                    mb: 1,
                    dialogMB: false,
                    oggetto: '',
                    testo: '',
                    validMB: false,
                    loading: {value:false, progress:0, indeterminate:true},
                    loadingMB: false,
                    esitoMBOK: false,
                    esitoMBKO: false,
                    search: '',
                    storico: false,
                    searchText: '',
                    listaCliente: [],
                    praticheEstese: [],
                    pratica: {
                        id:'0',
                        tipoPratica: {
                            id:'0'
                        }
                    },
                    headers: [
                        { text: 'Azioni', value: 'menu' },
                        { text: 'Tipologia', value: 'pratica.tipoPratica.descrizione', width: '15%' },
                        { text: 'Cliente', value: 'pratica.cliente.codice', sortable: true, width: '15%' },
                        { text: 'Creazione', value: 'creazione', sortable: false },
                        { text: 'Data Inizio', value: 'pratica.dataInizio' },
                        { text: 'Data Scadenza', value: 'pratica.dataScadenza' },
                        { text: 'Operatori con Task Aperti', value: 'operatoriAperti',sortable:false },
                        { text: 'Operatori con Task Completati', value: 'operatoriChiusi', sortable: false },
                        { text: 'Task aperti/completati', value: 'task', sortable: false },                      
                        { text: 'Chiusa/Addebitata', value: 'chiusa' },
                    ],
                    headers1: [
                        { text: 'Azioni', value: 'menu' },
                        { text: 'Tipologia', value: 'pratica.tipoPratica.descrizione', width: '15%' },
                        { text: 'Cliente', value: 'pratica.cliente.codice', sortable: true, width: '15%' },
                        { text: 'Creazione', value: 'creazione', sortable: false },
                        { text: 'Data Inizio', value: 'pratica.dataInizio' },
                        { text: 'Data Scadenza', value: 'pratica.dataScadenza' },
                        { text: 'Operatori con Task in Lavorazione', value: 'operatoriProgress', sortable: false },
                        { text: 'Operatori con Task Aperti', value: 'operatoriAperti', sortable: false },
                        { text: 'Operatori con Task Completati', value: 'operatoriChiusi', sortable: false },
                        { text: 'Task in lavorazione/ aperti/completati', value: 'task1', sortable: false },
                        { text: 'Chiusa/Addebitata', value: 'chiusa' },
                    ],
                    oggetto:'',
                    testo: '',
                    dataA: '',
                    dataDa: '',
                    dataAs: '',
                    dataDas: '',
                    conteggioUtenti: [],
                    notifica: true,
                    operatore: { id: '' },
                    operatore2: { id: '' },
                    professionista: { id: '' },
                    cliente: { id: '' },
                    idCliente: '',
                    notifica1: true,
                    notifica2: true,
                    moneyOptions: {
                        locale: "it-IT",
                        prefix: "€",
                        suffix: "",
                        length: 10,
                        precision: 2
                    },
                    statoPratica: '4'
                }),
                methods: {
                    localData(v) {
                        return gLocalData(v);
                    },
                    importoEuro(v) {
                        return euro(v);
                    },
                    controllData(v) {
                        return gControllData(v);
                    },
                    dataCalendar(v) {
                        return gDataCalendar(v);
                    },
                    descrizioneApp(v) {
                        if (v == false) return "Mail/Telefono";
                        return "App StudioPro";
                    },
                    descrizioneRisposta(v) {
                        if (v == false) return "Non autorizzata";
                        return "Autorizzata";
                    },
                    async elimina(item) {
                        bus.$emit('msg-open', { message: "Eliminare la pratica?", item });
                        bus.$on('msg-cancel', this.eliminaCancel);
                        bus.$on('msg-ok', this.eliminaOk);
                    }, 
                    async eliminaCancel(item) {
                        bus.$off('msg-cancel', this.eliminaCancel);
                        bus.$off('msg-ok', this.eliminaOk);
                    },
                    async eliminaOk(item) {
                        bus.$off('msg-cancel', this.eliminaCancel);
                        bus.$off('msg-ok', this.eliminaOk);

                        let param = {
                            partition: this.$store.state.partition,
                            username: this.$store.state.utente.username,
                            token: this.$store.state.utente.token,
                            sessionID: this.$store.state.sessionID,
                            id: item.id
                        };

                        this.loading.value = true;

                        const result = await callPost('api/pratica/eliminaPratica', param);

                        if (result) {
                            await this.internalCreated(Snack.success);
                        }
                        else {
                            await this.internalCreated(Snack.error);
                        }
                        loading.value = false;
                    },
                    filterItems(v){
                        this.$nextTick(() => {
                            this.filtro=this.$refs.tabella.$children[0].filteredItems;
                        });
                    },
                    anagrafica(pratica) {
                        this.pratica = JSON.parse(JSON.stringify(pratica));
                        if(this.$store.state.conf.isService) {
                            bus.$emit('dialog-show-servizio', this.pratica);
                        }
                        else {
                            bus.$emit('dialog-show-pratica', this.pratica);
                        }
                    },
                    nuovo() {
                        this.pratica = {
                            id: "0",
                            tipoPratica: { id:"0"},
                            cliente: {
                                id: "0", tipoCliente: {id:"0"},},
                            operatoreCreazione: { id:"0"}
                        }

                        if(this.$store.state.conf.isService) {
                            bus.$emit('dialog-show-servizio', this.pratica);
                        }
                        else {
                            bus.$emit('dialog-show-pratica', this.pratica);
                        }
                    },
                    toggleAll() {
                        this.statoAll = !this.statoAll;
                        this.$store.dispatch('setStatoAll',this.statoAll);

                        if(this.statoAll) {
                            this.selezione=this.filtro;
                        }
                        else {
                            this.selezione=[];
                        };
                        this.$store.dispatch('setSelezione',this.selezione);
                    },
                    toggleSelect() {
                        this.$nextTick(() => {
                            this.$store.dispatch('setSelezione',this.selezione);
                        });
                    },
                    setTagRicerca(tag) {
                        this.searchText = tag;
                        this.changeSearch();
                    },
                    async onPraticaChanged({ lista, sessionID }) {

                        if (sessionID == this.$store.state.sessionID) return;
                        for (var i = 0; i < lista.length; i++) {

                            let param = [lista[i]];
                            let praticaEstesa = await callService("api/pratica/pratica", param);

                            let pratica = praticaEstesa.pratica;

                            //cerco nella lista la pratica ricalcolata

                            const index = this.praticheEstese.findIndex(u => {
                                return u.pratica.id === pratica.id;
                            });

                            if (index >= 0) {
                                this.praticheEstese.splice(index, 1, praticaEstesa);
                            }
                            else {
                                this.praticheEstese.push(praticaEstesa);
                            }
                        }
                    },                    
                    async onPraticaDeleted({ lista, sessionID }) {

                        if (sessionID == this.$store.state.sessionID) return;
                        for (var i = 0; i < lista.length; i++) {

                            let idPratica = lista[i];
                            
                            //cerco nella lista la pratica eliminata

                            const index = this.praticheEstese.findIndex(u => {
                                return u.pratica.id === idPratica;
                            });

                            if (index >= 0) {
                                this.praticheEstese.splice(index, 1);
                            }                            
                        }
                    },
                    onSnackSuccess() {
                        this.snackSuccess = true;
                    },
                    pagination(pag) {
                        let nPag = pag.itemsPerPage;
                        this.$cookie.set('pratiche-pagination', nPag.toString(), { expires: '1Y' });
                    },
                    async internalCreated(snack) {
                        this.praticheEstese.length=0;

                        //this.loading.value = true;
                        //this.loading.progress = 0;
                        //let param = [this.$store.state.conf.isService,this.storico];
                        //this.praticheEstese = await callService('api/pratica/lista', param);
                        //this.loading.value = false;
                        //console.log(JSON.stringify(this.praticheEstese));
                        this.listaCliente = this.$store.state.clientiEstesi; 
                        await gSynch6(this.$store.state.conf.isService,this.storico,this.loading,this.praticheEstese,this.idCliente);                        
                        
                        this.search = "x"; //faccio partire il filtro perché chiedo tutte le prstiche ma filtro sulle aperte
                        this.snackSuccess = (snack == Snack.success);
                        this.snackError = (snack == Snack.error);
                        this.snackCancel = (snack == Snack.cancel);
                        this.snackRemote = (snack == Snack.remote);
                    },
                    customFilter(value, search, item) {
                        //console.log(JSON.stringify(item));
                        let ok = true;
                        if (ok && this.searchText) { //codice/dnz/fiscale in OR
                            let src = this.searchText.toLowerCase();
                            let ok1 = item.pratica.descrizione && item.pratica.descrizione.toLowerCase().indexOf(src) >= 0;
                            let ok2 = !ok1 && item.pratica.tipoPratica.descrizione.toLowerCase().indexOf(src) >= 0;
                            let ok3 = !ok1 && !ok2 && item.pratica.cliente && item.pratica.cliente.codice && item.pratica.cliente.codice.toLowerCase().indexOf(src) >= 0;
                            let ok4 = !ok1 && !ok2 && !ok3 && item.pratica.cliente.denominazioneNormalizzata.toLowerCase().indexOf(src) >= 0;
                            let ok5 = !ok1 && !ok2 && !ok3 && !ok4 && item.pratica.numeroPratica && item.pratica.numeroPratica.toLowerCase().indexOf(src) >= 0;
                            let ok6 = !ok1 && !ok2 && !ok3 && !ok4 && !ok5 && item.pratica.tags && item.pratica.tags.toLowerCase().indexOf(src) >= 0;
                            ok = ok1 || ok2 || ok3 || ok4 || ok5 || ok6;
                        }

                        if (ok && this.professionista.id) {
                            ok = item.pratica.cliente.professionista.id == this.professionista.id;
                        }
                        
                        if (ok && this.operatore.id) {
                            let ok1 = item.listaOperatoriTaskAperti.findIndex(o => o.id == this.operatore.id) >= 0;
                            let ok2 = item.listaOperatoriTaskChiusi.findIndex(o => o.id == this.operatore.id) >= 0;
                            let ok3 = item.listaOperatoriTaskProgress.findIndex(o => o.id == this.operatore.id) >= 0;
                            ok = ok1 || ok2 || ok3;
                        }    

                        if (ok && this.operatore2.id) {
                            let ok1 = item.listaOperatoriTaskAperti.findIndex(o => o.id == this.operatore2.id) >= 0;
                            let ok2 = item.listaOperatoriTaskChiusi.findIndex(o => o.id == "XXX") >= 0;
                            let ok3 = item.listaOperatoriTaskProgress.findIndex(o => o.id == this.operatore2.id) >= 0;
                            ok = ok1 || ok2 || ok3;
                        }    

                        if (this.$store.state.conf.isService) {
                            if (ok) {
                                if (this.statoPratica == '2') //TUTTI//
                                    ok = ok;
                                else if (this.statoPratica == '1') //APERTE
                                    ok = !item.pratica.isChiusa
                                else if (this.statoPratica == '5') //DA ADDEBITARE
                                    ok = (item.isAddebitabile && !item.pratica.contratto) || (item.isAddebitabile && item.pratica.contratto && item.pratica.importo > 0)
                                else if (this.statoPratica == '3') //CHIUSE
                                    ok = item.pratica.isChiusa
                                else if (this.statoPratica == '4') //IN Lavorazione
                                    ok = item.taskProgress > 0
                            }

                            if (ok) {
                                if (this.isApp) {
                                    ok = item.pratica.isApp;
                                }
                            }
                        }
                        else
                        {
                            if (ok) {
                                if (this.statoPratica == '2') //TUTTI//
                                    ok = ok;
                                else if (this.statoPratica == '4' || this.statoPratica == '1') //APERTE
                                    ok = !item.pratica.isChiusa
                                else if (this.statoPratica == '5') //DA ADDEBITARE
                                    ok = item.isAddebitabile
                                else if (this.statoPratica == '3') //CHIUSE
                                    ok = item.pratica.isChiusa
                            }
                        }


                        if (ok && this.dataDa) {
                            ok = this.dataCalendar(item.pratica.dataInizio) >= this.dataCalendar(this.dataDa);
                        }
                        if (ok && this.dataA) {
                            ok = this.dataCalendar(item.pratica.dataInizio) <= this.dataCalendar(this.dataA);
                        }

                        if (ok && this.dataDas) {
                            ok = this.dataCalendar(item.pratica.dataScadenza) >= this.dataCalendar(this.dataDas);
                        }
                        if (ok && this.dataAs) {
                            ok = this.dataCalendar(item.pratica.dataScadenza) <= this.dataCalendar(this.dataAs);
                        }
                     
                        return ok;
                    },
                    changeSearch() {
                            this.search =
                            this.searchText +
                            this.operatore.id + this.operatore2.id +                          
                            this.statoPratica + this.dataDa + this.dataA +
                            this.dataDaS + this.dataAS
                    },
                    async change() {
                         await this.internalCreated(Snack.nothing);
                    },                      
                    changeSwitchCliente() {
                        this.idCliente='';
                    }                    
                },
                computed: {
                    hintSelezione() {
                        if(this.selezione.length==1) return "1 scadenza selezionata su "+this.filtro.length;
                        if(this.selezione.length>1) return this.selezione.length+" scadenze selezionate su "+this.filtro.length;
                        return "";
                    },
                    labelMB() {
                        return "Comunicazioni ai clienti (" + this.selezione.length + ")";
                    },
                    labelNuove() {
                        return this.selezione.filter(s => s.dataInvioRichiesta == null && s.dataRisposta == null).length;
                    },
                    labelSollecito() {
                        return this.selezione.filter(s => s.dataInvioRichiesta != null && s.dataRisposta == null).length;
                    },
                    labelNoMessaggi() {
                        return this.selezione.filter(s => s.dataInvioRichiesta != null && s.dataRisposta != null).length;
                    },                                     
                },                
                async created() {

                    this.clientiEstesi = this.$store.state.clientiEstesi;
                    this.listaOperatore = this.$store.state.listaOperatore;
                    this.listaOperatoriProfessionisti = this.$store.state.listaOperatoriProfessionisti;

                    bus.$on('pratica-changed', this.onPraticaChanged);
                    bus.$on('pratica-deleted', this.onPraticaDeleted);
                    bus.$on('pratica-snack-succes', this.onSnackSuccess);

                    this.nPag = Number(this.$cookie.get('pratiche-pagination')); //leggo il coockie della paginazione

                    if (this.$store.state.utente.operatore.isAccessoLimitato && !this.$store.state.utente.isGestoreStudio && this.$store.state.utente.operatore.isProfessionista)
                    {
                        this.professionista.id = this.$store.state.utente.operatore.professionista.id;
                        this.isAccessoLimitatoP = true;
                    }
                    else if (this.$store.state.utente.operatore.isAccessoLimitato && !this.$store.state.utente.isGestoreStudio)
                    {
                        this.operatore.id = this.$store.state.utente.operatore.id;
                        this.isAccessoLimitatoO = true;
                    }

                    await this.internalCreated(Snack.nothing);

                    
                },
                beforeDestroy() {
                    bus.$off('pratica-changed', this.onPraticaChanged);
                    bus.$off('pratica-deleted', this.onPraticaDeleted);
                    bus.$off('pratica-snack-succes', this.onSnackSuccess);
                },
                async mounted() {      
                    //alert('mounted');              
                    //sul refresh ricarico i clienti
                    //await gSynch6(this.$store.state.conf.isService,false,this.loading,this.praticheEstese);
                
                 }
            }
</script>



